module.exports = {
    'rundown_tab': {
        functions: [
            'saveWidgetForItem',
            'getWidgetFromItem',
            'setAmountForItem',
            'addAmountForItem',
            'subtractAmountForItem',
            'setAmount',
            'addAmount',
            'subtractAmount',
            'startDnd',
            'stopDnd',
            'createDndObject',
            'requestAuthorizationKey',
            'popup',
            'fetch',
        ],
        events: [
            'initialize',
            'droppedOnItem',
            'selectedItem',
            'authorizationKey',
        ]
    },
    'rundown_item': {
        functions: [
            'saveWidget',
            'setHeight',
            'setAmount',
            'addAmount',
            'subtractAmount',
            'requestAuthorizationKey',
            'popup',
            'fetch',
        ],
        events: [
            'initialize',
            'itemDataUpdate',
            'updateWidget',
            'authorizationKey',
            'screenResize',
        ]
    },
    'rundown_live': {
        functions: [
            'setHeight',
            'requestAuthorizationKey',
            'publishToOthers',
            'fetch',
            'fetch',
        ],
        events: [
            'initialize',
            'publishToOthers',
            'authorizationKey',
        ]
    },
    'menu': {
        functions: [
            'requestAuthorizationKey',
            'popup',
            'fetch',
        ],
        events: [
            'initialize',
            'authorizationKey',
        ]
    },
    'field': {
        functions: [
            'saveWidget',
            'setHeight',
            'requestAuthorizationKey',
            'popup',
            'fetch',
        ],
        events: [
            'initialize',
            'save',
            'updateWidget',
            'authorizationKey',
        ]
    },
    'remote_settings': {
        functions: [
            'saveWidget',
            'setHeight',
            'requestAuthorizationKey',
            'popup',
            'fetch',
        ],
        events: [
            'initialize',
            'save',
            'updateWidget',
            'authorizationKey',
        ]
    },
    'popup': {
        functions: [
            'setHeight',
            'setWidth',
            'popupEmitter',
            'fetch',
        ],
        events: [
            'initialize',
            'screenResize',
        ]
    },
};